import type { ReactNode } from 'react';
import { Button } from '@finn-auto/design-system/atoms/button';

/**
 * Standard right-aligned footer row for ALL TA board modals (Cancel ghost +
 * primary action). Deliberately NOT the design-system ModalFooter: below the
 * DS md breakpoint (1120px — most laptops) that footer renders as
 * `size-full flex-col`, which stacks Cancel above the primary button and
 * stretches over the modal's leftover height (the "huge empty space" bug).
 */
export function ModalActions({
  confirmLabel,
  confirmDisabled,
  cancelLabel = 'Cancel',
  onConfirm,
  onCancel,
}: {
  confirmLabel: ReactNode;
  confirmDisabled?: boolean;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  return (
    <div className="flex w-full flex-wrap items-center justify-end gap-2 pt-2">
      <Button variant="ghost" onClick={onCancel}>
        {cancelLabel}
      </Button>
      <Button onClick={onConfirm} disabled={confirmDisabled}>
        {confirmLabel}
      </Button>
    </div>
  );
}
